export type TResultSuggestion = IAddressSuggest | ICitySuggest;

export interface IAddressSuggest {
  displayName: string;
  type: ESuggestType.geo;
  value: string;
  hl: IYmapsCoord[];
}

export interface ICitySuggest {
  id: number;
  regionId?: number;
  displayName: string;
  matches?: IYmapsCoord[];
  type: ESuggestType.city;
  value: string;
}

export type IYmapsCoord = [number, number];

export enum ESuggestType {
  city = 'city',
  district = 'district',
  railway = 'railway',
  underground = 'underground',
  businessCenter = 'businessCenter',
  shoppingCenter = 'shoppingCenter',
  road = 'road',
  village = 'village',
  newbuilding = 'newbuilding',
  geo = 'geo',
  builder = 'builder',
  coworking = 'coworking',
}
